export const getScoreOn20AsInt = (value) => {
  let v20 = value * 20;
  if (v20 > 0 && v20 <= 1) return 1;
  v20 = Math.round(v20);
  return v20;
};

export const getScoreOn20 = (value) => {
  const v20 = getScoreOn20AsInt(value);
  if (value === 0) return '0';
  return v20 < 10 ? `0${v20}` : `${v20}`;
};

export const isNumber = (value) => {
  return !isNaN(parseFloat(value)) && isFinite(value);
};
